<template>
  <div class="copy-text">
    <input class="copy-field" type="text" v-model="text" ref="input" readonly="readonly" />
    <span v-if="$vuetify.breakpoint.smAndUp" @click="handelClick()">{{ $t('actions.copy') }}</span>
    <span v-else @click="handelClick()"><v-icon color="var(--white)" size="16">mdi-content-copy</v-icon></span>
  </div>
</template>

<script>
export default {
  name: 'CopyText',
  props: ['text'],
  data() {
    return {};
  },
  methods: {
    handelClick() {
      const input = this.$refs.input;
      input.select();
      document.execCommand('copy');
      this.successNotify(this.$t('success.copy'));
    }
  },
  computed: {},
  mounted() {}
};
</script>

<style lang="stylus" scoped>
.copy-text {
  background: rgba(230, 234, 240, 0.5);
  border: 1px solid rgba(230, 234, 240, 1);
  opacity: 1;
  border-radius: 2px;
  display: flex;
  align-items: center;
}
.copy-field {
  width: 100%;
}
.copy-text input {
  flex: 1 1 0px;
  background-color: transparent;
  padding: 0 10px;
}
.copy-text span {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  margin: 4px 10px;
  line-height: 36px;
  display: flex;
  padding: 0 20px;
  height: 36px;
  background: rgba(77, 103, 178, 1);
  border-radius: 2px;
  font-size: 14px;
  color: rgba(255, 255, 255, 1);
  cursor: pointer;
  user-select: none;
  min-width: 56px;
}
.copy-text span:hover {
  opacity: 0.8;
}
.copy-text span:active {
  opacity: 0.9;
}

@media screen and (max-width: 599px) {
  .copy-text span {
    min-width: 40px;
    padding: 0 13px;
  }
}
</style>
